export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/imageCompressWebpackWorker.1dae4e15.worker.js");
}
